export function initEffects() {
	// ScrollReveal
	if (typeof ScrollReveal !== "undefined") {
		ScrollReveal().reveal(".fd-up", {
			origin: "bottom",
			distance: "20px",
			duration: 1000,
			delay: 200,
			easing: "cubic-bezier(0.5, 0, 0, 1)",
			once: true
		});
	}

	// Lozad (lazy load)
	if (typeof lozad !== "undefined") {
		const observer = lozad(".lozad", {
			rootMargin: "10px",
			threshold: 0.2
		});
		observer.observe();
	}

	// Fancybox
	if (typeof Fancybox !== "undefined") {
		Fancybox.bind("[data-fancybox]");
	}
}